<template>
  <div
    class="veneta-icon-wrapper"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false">
    <!-- Scoped slot that provides the VenetaIcon props -->
    <slot
      :veneta-icon-props="venetaIconProps"
      :is-hovered="isHovered"></slot>
  </div>
</template>

<script setup>
  import { computed, ref } from 'vue'

  const props = defineProps({
    // VenetaIcon props that can be customized
    iconWidth: {
      type: [ Number, String ],
      default: 24
    },
    iconHeight: {
      type: [ Number, String ],
      default: 24
    },
    iconColor: {
      type: String,
      default: 'red'
    }
  })

  // Internal hover state
  const isHovered = ref(false)

  // Computed props for the VenetaIcon
  const venetaIconProps = computed(() => ({
    width: props.iconWidth,
    height: props.iconHeight,
    color: props.iconColor,
    isHovered: isHovered.value
  }))
</script>
